import { TERTIARY } from "../../Global/GlobalConstants";
import SubscriptionForm from "./SubscriptionForm";

function GatedContent() {
  return <SubscriptionForm showGatedContent={true} theme={TERTIARY} />;
}

export default GatedContent;
